import { SET_LIST_PARENT } from './parentConst';

export function setListParent(parent) {
  return {
    type: SET_LIST_PARENT,
    parent
  };
}
